const main = [
    {
        depth2: '메인',
        depth3: '',
        depth4: '',
        depth5: '',
        name: '메인',
        type: 'PAGE',
        dir: 'mai',
        id: 'SC-MAI-0000-F',
        plan: '25.07.14',
        end: '25.07.14',
        user: '김익중',
        state: '완료',
        etc: '',
        uxw: true,
    },
    {
        depth2: '영업점홈',
        depth3: '',
        depth4: '',
        depth5: '',
        name: '지점별 메인',
        type: 'PAGE',
        dir: 'mai',
        id: 'SC-BOB-0000-F',
        plan: '25.07.16',
        end: '25.07.16',
        user: '김익중',
        state: '완료',
        etc: '',
        uxw: true,
    },
    {
        depth2: '지점소개',
        depth3: '',
        depth4: '',
        depth5: '',
        name: '지점소개',
        type: 'POPUP',
        dir: 'mai',
        id: 'SC-BOB-0001-P',
        plan: '25.07.04',
        end: '25.07.04',
        user: '김익중',
        state: '완료',
        etc: '',
        uxw: true,
    },
]

export default main
